import {formatProductTerm} from "../../utils/helpers";
import Select, {CustomSelect} from "../Form/Select/Select";
import React from "react";

/** @import {ValueType} from "react-select" */
/** @import {OptionType} from "../Form/Select/SelectTypes" */
/** @import {Account, Product} from "../../contexts/CustomerDataProviderTypes" */
export function MaturityTerm(/** @type {{ maturingAccount: Account | undefined; products: Product[]; selectedProduct: string | undefined;
                              setSelectedProduct: React.Dispatch<React.SetStateAction<string | undefined>>; applyMaxWidth?:boolean; isDisabled?:boolean }} */
                             { maturingAccount, products, selectedProduct, setSelectedProduct, applyMaxWidth=true, isDisabled=false }) {

    const renderTermOptions = (/** @type {Product[]} */ products) => {

        const getRate = (/** @type {number} */ ntbInterestRate, /** @type {number} */ rolloverRate) => {
            const displayNtBRate = ntbInterestRate > rolloverRate
            return displayNtBRate ? ntbInterestRate : rolloverRate.toFixed(2);
        }

        const mapProducts = (/** @type {Product[]} */ products) => {
            return products.map(p => {
                let rolloverRate = 0;
                if (maturingAccount?.maturity?.availableRolloverRates) {
                    var productRate = maturingAccount.maturity.availableRolloverRates.find(r => r.productId === p.id)
                    if (productRate) {
                        rolloverRate = productRate.rate;
                    }
                }

                return {
                    label: `${formatProductTerm(p.productTerm, false)} term - ${rolloverRate.toFixed(2)}% AER*/gross`,
                    value: p.id
                }
            });
        }

        const findExistingProduct = (/** @type {string} */ currentProduct, /** @type {ValueType<OptionType, false>[]} */ allProducts) => {
            const existingProduct = allProducts.find(p => p?.value === currentProduct);
            return existingProduct || null;
        }

        const handleChange = (/** @type {string} */ option) => {
            setSelectedProduct(option);
        }


        return (
            <CustomSelect
                name="term"
                placeholder="Select the term"
                options={mapProducts(products)}
                value={findExistingProduct(selectedProduct || "", mapProducts(products || []))}
                onChange={option => option && handleChange(option.value)}
                isDisabled={isDisabled}
            />
        );
    }
    const className = applyMaxWidth ? 'maturity3__flex-row--equal-width-child' : 'maturity3__flex-row--equal-width-child-max-width';

    return (
        <div className={className}>
            {renderTermOptions(products)}
        </div>
    );
}